import { Formik, Form } from 'formik';
import { observer } from 'mobx-react-lite';
import React from 'react';
//import { UserActivity, ProfileFormValues } from '../../../app/models/userActivity';
import { UserActivity } from '../../../app/models/userActivity';
import * as Yup from 'yup';
import MyTextInput from '../../../app/common/form/MyTextInput';
import MyTextArea from '../../../app/common/form/MyTextArea';
import { Button } from 'semantic-ui-react';
import { useStore } from '../../../app/stores/store';
import { useNavigate } from 'react-router-dom';

interface Props {
    //profile: UserActivity; //.o
    setEditProfileMode: (editProfileMode: boolean) => void; //'n >> takes editMode of type boolean and return  void
}

//function ProfileEditForm({profile}: Props) { //.
function ProfileEditForm(props: Props) { //'n
    const usStore = useStore();

    let msgRequired = 'This field is required!';
    const validationSchema = Yup.object({
        displayName: Yup.string().required(msgRequired),
        bio: Yup.string(),
    });

    //function handleSubmitForm(values: UserActivity) { //. it works
    //function handleSubmitForm(values: ProfileFormValues) {
    function handleSubmitForm(values: Partial<UserActivity>) {
        if(values) {
            console.log(values);
            usStore.profileStore.updateProfile(values).then(() => {
                props.setEditProfileMode(false); //'n
            });
        }
    }

    return (
        // <p>Edit profile here!</p>
        <Formik 
            //initialValues={usStore.profileStore.profile!} //.o
            initialValues={{ //'n
                displayName: usStore.profileStore.profile?.displayName, 
                bio: usStore.profileStore.profile?.bio, 
            }}
            //enableReinitialize //'nn
            validationSchema={validationSchema}
            onSubmit={values => handleSubmitForm(values)}
        >
            {/* {({handleSubmit, isSubmitting, isValid, dirty}) => ( */}
            {({isSubmitting, isValid, dirty}) => (
                // <Form className='ui form' onSubmit={handleSubmit} autoComplete='off' > //.o
                <Form className='ui form' > 
                    <MyTextInput placeholder={'Display Name'} name={'displayName'} />
                    <MyTextArea placeholder={'Add your bio'} name={'bio'} rows={5} />
                    {/* <Button type='submit' content='Update' positive floated='right' loading={usStore.profileStore.isLoading} disabled={usStore.profileStore.isLoading || !isValid || !dirty} /> */}
                    <Button type='submit' content='Update' positive floated='right' loading={isSubmitting} disabled={!isValid || !dirty} />
                </Form>
            )}
            
        </Formik>
    )
}

export default observer(ProfileEditForm);